import { CommonModule, PlatformLocation } from "@angular/common";
import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthenticatorModule } from "@indusoft/authenticator";
import { AasAuthenticatiorComponent } from "./components/aas-authenticator.component";
import { ConfigurationHttpService } from "../../common/services/configuration.service";
import { BaseRouteInterceptor } from '../../common/core/base-route.interceptor';
import { AasGateInterceptor } from "../services/aas-gate-interceptor";

@NgModule({
    declarations: [AasAuthenticatiorComponent],
    imports: [CommonModule, AuthenticatorModule],
    exports: [AasAuthenticatiorComponent],
    providers: [
        ConfigurationHttpService,
        { provide: HTTP_INTERCEPTORS, useClass: BaseRouteInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AasGateInterceptor, multi: true }
    ],
})
export class AasAuthenticatorModule { }

export function getBaseHref(platformLocation: PlatformLocation): string {
    return platformLocation.getBaseHrefFromDOM();
}
